function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitchHorizontal01 = function SvgSwitchHorizontal01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.195 1.527a.67.67 0 0 1 .942 0l2.668 2.668a.663.663 0 0 1 0 .942l-2.668 2.668a.664.664 0 0 1-.934-.008.664.664 0 0 1-.008-.934l1.528-1.531H2.668a.665.665 0 1 1 0-1.332h9.055l-1.528-1.527a.667.667 0 0 1 0-.946m-4.39 6.668a.663.663 0 0 1 0 .942l-1.528 1.531h9.055a.665.665 0 1 1 0 1.332H4.277l1.528 1.527a.68.68 0 0 1 .183.649.668.668 0 0 1-1.125.297l-2.668-2.668a.663.663 0 0 1 0-.942l2.668-2.668a.663.663 0 0 1 .942 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fillOpacity: 1
    }
  }));
};
export default SvgSwitchHorizontal01;